export default __webpack_public_path__ + "static/media/ic_balearic_islands.0237cf15.svg";